var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-end"},[_c('div',{staticClass:"fw-bold"},[_vm._v(_vm._s(_vm.getName))]),_vm._v(_vm._s(_vm.getDetailAcc.level_name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }